import kapaiImage from '@/static/image/kapai.png'
import transportImage from '@/static/image/transport.png'
import lastmileImage from '@/static/image/lastmile.png'
import integrationImage from '@/static/image/integration.png'

interface coreBusinessItem {
  id: number
  title: string
  time: string
  desc: string
  image: string
  type:
    | 'oversizedproducts'
    | 'cardfaction'
    | 'firstlegcargo'
    | 'overseaswarehouse'
}

export const coreBusinessList: coreBusinessItem[] = [
  {
    id: 1,
    type: 'oversizedproducts',
    title: '超大件产品尾程物流派送',
    desc: 'EFFICROSS',
    image: kapaiImage,
    time: '2024-04-25',
  },
  {
    id: 2,
    type: 'cardfaction',
    title: '卡派Q&A',
    desc: 'EFFICROSS',
    image: transportImage,
    time: '2024-04-22',
  },
  {
    id: 3,
    type: 'firstlegcargo',
    title: '头程货物运输',
    desc: 'EFFICROSS',
    image: lastmileImage,
    time: '2024-04-22',
  },
  {
    id: 4,
    type: 'overseaswarehouse',
    title: '海外仓',
    desc: 'EFFICROSS',
    image: integrationImage,
    time: '2024-04-22',
  },
]
